'use client'
import { ChatContainer } from './components/chat-container'
import { ThemeProvider } from './lib/themeContext'
import { themes } from './lib/themes'
import { useState, useEffect } from 'react'

export const runtime = 'nodejs'

function getSubdomain() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const subdomain = hostname.split('.')[0] // Extract subdomain
  return subdomain
}

export default function Page() {
  // Use state to store the theme
  const [currentTheme, setCurrentTheme] = useState<null | any>(null)

  // Only set the theme after component mounts on the client
  useEffect(() => {
    const subdomain = getSubdomain()
    const theme = themes[subdomain as keyof typeof themes] || themes.titan
    setCurrentTheme(theme)
  }, [])

  // Show nothing until we have determined the correct theme
  if (!currentTheme) {
    return null // Or return a loading spinner if preferred
  }

  return (
    <ThemeProvider theme={{ ...currentTheme }}>
      <ChatContainer />
    </ThemeProvider>
  )
}
